/* src/app/hire-person-search/hire-candidate-slider/hire-slider-ai-insights-view/hire-slider-ai-insights-view.component.scss */
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #68AA86;
  display: flex;
  background:
    linear-gradient(
      0deg,
      rgba(104, 170, 134, 0.1) 0%,
      rgba(104, 170, 134, 0.1) 100%),
    #FFF;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.errror {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  outline: none;
  border: 0px;
  font-size: 12px;
  height: 36px;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
  font-size: 12px;
  font-weight: 500;
  position: relative;
}
.toggle-container .activebtn,
.toggle-container .activeClass {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .insight-btn,
.toggle-container .profile-btn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  position: relative;
  cursor: pointer;
}
.toggle-container .insight-btn:hover,
.toggle-container .profile-btn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .profile-btn.activeClass {
  left: -50%;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.back-link-btn {
  background-color: transparent;
  color: #484b59;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.files-card {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  background: #FCFCFC;
  flex-direction: column;
  margin-bottom: 10px;
}
.btn-svg {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 5px;
}
::ng-deep .progress {
  background-color: #F4F4F4 !important;
  border-radius: 10px !important;
}
::ng-deep .progress-bar {
  border-radius: 10px !important;
}
::ng-deep .progress-bar.text-bg-success {
  background-color: #2E93A1 !important;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 34px;
}
.label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.contact-cta {
  display: flex;
  width: 16px;
  height: 16px;
  padding: 3.326px 3px 2.674px 3px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: #E6F2F4;
}
.helpfull-label {
  display: flex;
  height: 18px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid #F2F2F2;
  background: #FAFAFA;
}
.table-view,
.table-view-3-column {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  overflow: hidden;
}
.table-view .table-header-row,
.table-view .table-body-row,
.table-view-3-column .table-header-row,
.table-view-3-column .table-body-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  background-color: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col,
.table-view .table-header-row .table-body-col,
.table-view .table-body-row .table-header-col,
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  width: 30%;
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  align-content: start;
  border-right: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col:last-child,
.table-view .table-header-row .table-body-col:last-child,
.table-view .table-body-row .table-header-col:last-child,
.table-view .table-body-row .table-body-col:last-child,
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 70%;
}
.table-view .table-header-row .table-header-col:first-child,
.table-view .table-header-row .table-body-col:first-child,
.table-view .table-body-row .table-header-col:first-child,
.table-view .table-body-row .table-body-col:first-child,
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 30%;
}
.table-view .table-body-row,
.table-view-3-column .table-body-row {
  background-color: #ffffff;
}
.table-view .table-body-row:last-child,
.table-view-3-column .table-body-row:last-child {
  border-bottom: none;
}
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-body-row .table-body-col {
  color: #5E5E5E;
  font-weight: 400;
}
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  border-right: 1px solid #F2F2F2;
  width: 40%;
  align-content: start;
  gap: 0;
}
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 40%;
}
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 24%;
}
::ng-deep ngb-pagination .pagination .page-item a.page-link {
  font-size: 12px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: 500px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
.hire-search-card-filters {
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  height: 80vh;
}
.toggle-container2 {
  position: relative;
  display: inline-flex;
  background: #e5e5e5;
  border-radius: 20px;
  padding: 4px;
  cursor: pointer;
}
.toggle-container2 span {
  position: relative;
  z-index: 2;
  padding: 6px 16px;
  font-size: 14px;
  color: #555;
  transition: color 0.3s ease;
}
.toggle-container2 span.active {
  color: #fff;
}
.toggle-slider2 {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 50%;
  height: calc(100% - 8px);
  background: #28a745;
  border-radius: 20px;
  transition: transform 0.3s ease;
  z-index: 1;
  color: #fff;
}
.toggle-slider2.insights {
  transform: translateX(100%);
}
.toggle-slider2.profiles {
  transform: translateX(0%);
}
.ml-auto {
  margin-left: auto;
}
.pos-sticky-top {
  position: sticky;
  top: 16px;
  z-index: 7;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.05);
}
.pos-sticky-top::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 16px;
  background-color: #fafbfc;
  top: -16px;
  left: 0;
}
.pipeline-export-modal-content {
  border-radius: 7px !important;
  overflow: hidden;
}
.pipeline-export-modal-content .modal-header {
  background-color: #f7f8f9;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
}
.pipeline-export-modal-content .modal-header .btn-close {
  background-color: #f7f8f9;
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-modal-content .modal-header .btn-close:focus,
.pipeline-export-modal-content .modal-header .btn-close:active {
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-options {
  display: flex;
  flex-direction: column;
}
.pipeline-export-options .pipeline-export-option {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.25rem;
  font-size: 13px;
  color: #484b59;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.pipeline-export-options .pipeline-export-option:last-child {
  border-bottom: none;
}
.pipeline-export-options .pipeline-export-option:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
.pipeline-export-options .pipeline-export-option.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.pipeline-export-options .pipeline-export-option-icon {
  width: 20px;
  margin-right: 10px;
  text-align: center;
  color: #969696;
}
@keyframes shimmer {
  0% {
    background-position: -600px 0;
  }
  100% {
    background-position: 600px 0;
  }
}
.sk-box {
  border-radius: 10px;
  background:
    linear-gradient(
      90deg,
      #f0f0f0 25%,
      #e0e0e0 50%,
      #f0f0f0 75%);
  background-size: 1200px 100%;
  animation: shimmer 1.6s infinite linear;
  flex-shrink: 0;
}
.skeleton-page {
  background: #fff;
  border-radius: 8px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
  font-size: 0;
}
.divider {
  height: 1px;
  background: #f0f0f0;
  margin: 8px 0;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.toolbar-actions {
  display: flex;
  gap: 6px;
}
.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}
.title-bar {
  width: 180px;
  height: 10px;
}
.icon-btn {
  width: 24px;
  height: 22px;
  border-radius: 4px;
}
.btn-lg {
  width: 110px;
  height: 28px;
  border-radius: 5px;
}
.btn-md {
  width: 80px;
  height: 28px;
  border-radius: 5px;
}
.subtitle-row {
  padding-left: 24px;
  margin-bottom: 6px;
}
.subtitle {
  width: 280px;
  height: 6px;
  border-radius: 10px;
}
.breadcrumb-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 24px;
}
.crumb {
  height: 6px;
  border-radius: 10px;
}
.crumb--sm {
  width: 80px;
}
.crumb--md {
  width: 120px;
}
.crumb--lg {
  width: 180px;
}
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex-shrink: 0;
}
.chips-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.chip-label {
  width: 90px;
  height: 6px;
}
.chip {
  height: 16px;
  border-radius: 12px;
  min-width: 60px;
}
.data-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.data-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 0;
}
.row-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}
.row-title {
  height: 13px;
  border-radius: 10px;
}
.meta-tag {
  height: 7px;
  border-radius: 10px;
}
.row-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.footer-card {
  height: 28px;
  border-radius: 5px;
}
.button {
  height: 28px;
  width: 115px;
  position: relative;
  border-radius: 0px 8px 8px 0px;
  background-color: #f4f4f4;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 0px;
  box-sizing: border-box;
}
.button-child {
  height: 28px;
  width: 16px;
  position: relative;
  flex-shrink: 0;
}
.vector-icon {
  height: 28px;
  width: 100%;
  position: relative;
  background-color: #eeeeee;
}
@media (prefers-reduced-motion: reduce) {
  .sk-box {
    animation: none;
    background: #eeeeee;
  }
}
.table-sk-view,
.table-sk-3-column-view {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  width: 100%;
}
.table-sk-view .table-sk-header,
.table-sk-3-column-view .table-sk-header {
  background: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
}
.table-sk-view .table-body-row,
.table-sk-3-column-view .table-body-row {
  border-bottom: 1px solid #F2F2F2;
  width: 100%;
  display: flex;
  background-color: #fff;
}
.table-sk-view .table-sk-col,
.table-sk-3-column-view .table-sk-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
  width: 30%;
}
.table-sk-view .table-sk-col:last-child,
.table-sk-3-column-view .table-sk-col:last-child {
  border-right: none;
  width: 70%;
}
.table-sk-3-column-view .table-sk-3-col {
  border-right: 1px solid #F2F2F2;
  padding: 12px 16px;
}
.table-sk-3-column-view .table-sk-3-col:last-child {
  border-right: none;
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:nth-of-type(2) {
  width: 35%;
}
.table-sk-3-column-view .table-sk-3-col:first-child {
  width: 30%;
}
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #969696;
  display: flex;
  background:
    linear-gradient(
      0deg,
      #F4F4F4 0%,
      #F4F4F4 100%),
    #FFF;
}
.common-chip .spinner-border {
  width: 12px;
  height: 12px;
  border-width: 1px;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.excellent {
  border-radius: 6px;
  color: #39B141;
  background:
    linear-gradient(
      0deg,
      rgba(57, 177, 65, 0.1) 0%,
      rgba(57, 177, 65, 0.1) 100%),
    #FFF;
}
.error {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.good {
  border-radius: 6px;
  color: #9CC535;
  background:
    linear-gradient(
      0deg,
      rgba(156, 197, 53, 0.1) 0%,
      rgba(156, 197, 53, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.criteria-label.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.criteria-label.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.criteria-label.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.good-fit {
  background: #F5F9F2;
  color: #9CC535;
}
.criteria-label.good-fit {
  background: #F5F9F2;
  color: #9CC535;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  border: 0;
  outline: none;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
}
.toggle-container .activebtn {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.br-1 {
  border-right: 1px solid #E5E5E5;
}
.mainContainer {
  display: flex;
  gap: 15px;
}
.projectScreenWidth {
  width: calc(100% - 215px);
}
.projectlistsidepanel {
  padding: 6px;
  border-radius: 4px;
  width: 200px;
  background-color: #ffffff;
}
.recommended-empty-screen {
  margin: 0 auto;
  width: 480px;
}
.howitworks {
  width: 70%;
  margin: 0 auto;
  padding: 10px 10px;
  border-radius: 4px;
  background-color: #F2F2F2;
}
label {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 500;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
::ng-deep .ngb-candidate-slider {
  width: 75% !important;
}
.criteria-label {
  display: flex;
  height: 24px;
  padding: 6px 9px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 14px;
  background-color: #F5F5F5;
  font-size: 12px;
  font-weight: 500;
}
.excellent-match {
  background-color: rgba(34, 147, 0, 0.1);
  color: #229300;
}
.w-100px {
  width: 100px;
}
.highlight-chip-container {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0px;
  align-items: center;
}
.highlight-chips {
  display: flex;
  padding: 5px 10px 5px 5px;
  align-items: flex-start;
  gap: 10px;
  color: #484B59;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 6px;
  margin-right: 6px;
  border-radius: 19px;
  border: 1px solid #F2F2F2;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
.ai-summary {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  font-size: 12px;
  font-weight: 500;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.text-summary {
  color: #E24F80;
}
.email-contact-badge {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  line-height: 0.5;
  border-radius: 4px;
  background: rgba(46, 147, 161, 0.1);
  height: 20px;
}
.btn-rerunAI-screening {
  display: flex;
  width: 142px;
  height: 28px;
  padding: 3px 8px;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  outline: none;
  border: none;
  margin-right: 10px;
  background:
    linear-gradient(
      267deg,
      rgba(200, 69, 171, 0.1) 15.14%,
      rgba(226, 78, 127, 0.1) 52.19%);
}
.btn-rerunAI-screening span.text {
  color: #D74B92;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
::ng-deep .highlight-chip-container {
  position: relative;
}
::ng-deep .highlight-chip-container .highlight-chips:first-child + ngb-tooltip-window {
  transform: translateX(102px) !important;
}
::ng-deep ngb-tooltip-window .tooltip-inner {
  max-width: 400px;
  padding: 0.5rem 0.5rem;
  color: #ffffff;
  text-align: left;
  background-color: #484b59;
  border-radius: 0.25rem;
  width: fit-content;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  will-change: inherit !important;
  border: 1px solid #484b59;
}
hr.highlight-tooltip-divider {
  margin: 8px 0;
}
.hiderule:last-child hr {
  display: none;
}
.contact-reveal {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  line-height: 0.5;
  border-radius: 4px;
  background: rgba(46, 147, 161, 0.1);
  height: 20px;
  opacity: 0.6;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
}
.contact-reveal:hover {
  opacity: 1;
}
.slider-container {
  padding: 16px 16px;
  position: relative;
  padding-top: 60px;
  display: flex;
  gap: 16px;
}
.slider-close-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  border-bottom: 1px solid #F5F5F5;
  background: #FAFBFC;
  padding: 13px 24px;
}
.slider-content-body {
  width: 65%;
}
.slider-side-panel {
  width: 35%;
  border-radius: 8px;
  border: 1px solid #f2f2f2;
  background-color: #fafafa;
  padding: 14px 14px;
  height: calc(100vh - 70px);
  overflow-y: auto;
}
.candidateDetialsSticky {
  padding-left: 12px;
}
.tags {
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 30px;
  border: 1px solid rgba(213, 222, 230, 0.4);
  background: #F4F9FA;
  margin-bottom: 6px;
  margin-right: 6px;
  color: #484B59;
  font-size: 12px;
}
.tab-container {
  display: flex;
  flex-direction: column;
  padding-top: 24px;
}
.tab-container nav {
  border-top: 1px solid #F2F2F2;
  border-bottom: 1px solid #F2F2F2;
}
.tab-container .navbar {
  padding: 0;
  background-color: #fff;
}
.tab-container ul.nav {
  margin-bottom: -2px;
}
.tab-container ul.nav li button {
  padding: 12px 12px;
}
.tab-container ul.nav li button.active {
  border-bottom: 2px solid #2e93a1;
  font-weight: 600;
  color: #2e93a1;
}
.tab-container ul.nav li .gen-ai-text.active {
  border-bottom: 2px solid #C845AB;
}
.tab-container ul.nav li button.nav-link {
  border-radius: 0;
  background-color: #fff;
  color: #484B59;
  font-size: 12px;
  font-weight: 500;
}
.tab-container ul.nav li button.nav-link.active {
  font-weight: 600;
  color: #2e93a1;
}
.gen-ai-text {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.selecttableviewBtn {
  border-radius: 30px;
  border: 1px solid #F2F2F2;
  padding: 4px 8px;
  background-color: #fafafa;
  font-size: 12px;
  height: auto;
  min-height: auto;
  width: fit-content;
  min-width: fit-content;
}
.table {
  font-size: 12px;
}
.thead td {
  font-weight: 500;
}
.tbody {
  font-weight: 400;
}
.highlight-chip-container {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
.highlight-chips {
  display: flex;
  padding: 5px 10px 5px 5px;
  align-items: flex-start;
  gap: 10px;
  color: #484B59;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 6px;
  margin-right: 6px;
  border-radius: 19px;
  border: 1px solid #F2F2F2;
}
.slider-close-header .disabled {
  opacity: 0.3;
  pointer-events: none;
  cursor: not-allowed;
}
div em {
  background-color: #FCE3A1 !important;
  font-style: normal !important;
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.good-fit {
  background: #F5F9F2;
  color: #9CC535;
}
.f-12 {
  font-size: 12px;
}
.add-to .selecttableviewBtn + .dropdown-menu.show {
  width: fit-content;
  min-width: fit-content;
  height: auto;
  padding: 4px 0;
  font-size: 12px;
}
.add-to .selecttableviewBtn + .dropdown-menu.show .dropdown-item {
  font-size: 12px;
}
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 400;
  border-right: 1px solid #F2F2F2;
  align-content: start;
  gap: 0;
}
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 48%;
}
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 22%;
}
.table-view-3-column .table-header-row .table-header-col:nth-of-type(2),
.table-view-3-column .table-header-row .table-body-col:nth-of-type(2),
.table-view-3-column .table-body-row .table-header-col:nth-of-type(2),
.table-view-3-column .table-body-row .table-body-col:nth-of-type(2) {
  width: 30%;
}
.table-view-3-column .table-header-row .table-header-col {
  font-weight: 500;
}
/*# sourceMappingURL=hire-slider-ai-insights-view.component-2YPRL42Q.css.map */
